import React from 'react'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { useTranslation } from 'react-i18next'
import { WarningEllipses } from '@/assets/icons'
import { responsiveAdapterVertical } from '@/utils/responsive'
import { links } from '@/constants/links'
export const RejectedKemCard: React.FC = () => {
  const { t } = useTranslation()
  const handleContactSupport = () => {
    // Open support link
    window.open(links.support, '_blank')
  }

  return (
    <BaseSafeFormView
      flex={1}
      bgColor="background.screen"
      className="h-full"
      align="center"
      justify="center"
    >
      <BaseView p={20} align="center" justify="center" gap={24} flex={1}>
        {/* Error Icon */}
        <BaseView
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: responsiveAdapterVertical(100),
          }}
        >
          <WarningEllipses size={110} />
          <BaseText fontSize={28} textAlign="center" fontFamily="semibold">
            {t('screens:cards.rejectedKemCardTitle')}
          </BaseText>
          <BaseText
            fontSize={16}
            textAlign="center"
            fontFamily="regular"
            color="label.description"
            lineHeight={20}
          >
            {t('screens:cards.rejectedKemCardDescription')}
          </BaseText>
          <BaseView
            mt={40}
            gap={12}
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <AppButton
              label={t('links:contactSupport')}
              type="secondaryGray"
              onPress={() => {
                handleContactSupport()
              }}
            />
          </BaseView>
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
